import { FEATURE_ALLOW_CUSTOM_DOMAIN } from 'App/features';
import { useStatusFeatureByKey } from 'domains/Auth/hooks';

export function useCustomDomainDisabled() {
  const { isAvailable } = useStatusFeatureByKey(FEATURE_ALLOW_CUSTOM_DOMAIN);
  return !isAvailable;
}
